import { useQuery } from "@tanstack/react-query";

import { downloadSectionSpecDrawing } from "@/shared/repositories/SectionSpecRepository";

export const useSectionSpecDrawing = (
	fileId: number | null,
	fileName: string | null,
	enabled = true,
) =>
	useQuery<Blob, Error>({
		queryKey: ["section-spec-drawing", fileId, fileName],
		queryFn: ({ signal }) =>
			downloadSectionSpecDrawing(fileId as number, fileName, signal),
		enabled: enabled && fileId !== null,
		staleTime: Number.POSITIVE_INFINITY,
		retry: false,
	});
